// @flow

import type {PaymentDetailDTO, Creditor} from '../../lib/definitions/swagger'
import type {Dispatch, Action, ThunkPromiseAction} from '../../lib/definitions/redux'


import * as loadingActions from './loading'
import WS from '../../lib/websocket'
import * as paymentAPI from '../../lib/api/payment'

export const BUDGET_UPDATE_PAYMENT_AWARENESS = 'BUDGET_UPDATE_PAYMENT_AWARENESS'
export const BUDGET_REMOVE_PAYMENT = 'BUDGET_REMOVE_PAYMENT'
export const BUDGET_UPDATE_PAYMENT = 'BUDGET_UPDATE_PAYMENT'
export const PAYMENT_GET_PAYEES = 'PAYMENT_GET_PAYEES'

export function updatePaymentAwareness(expenseId : string){
	return (dispatch : Dispatch) => loadingActions.promise(
		dispatch,
		[BUDGET_UPDATE_PAYMENT_AWARENESS, expenseId],
		paymentAPI.updatePaymentAwareness(expenseId)
			.then((id) => WS.waitFor(id))
			.then(() => dispatch(_setPaymentAwareness(expenseId)))
	)
}

function _setPaymentAwareness(id) : Action{
	return {
		type: BUDGET_UPDATE_PAYMENT_AWARENESS,
		id: id
	}
}

/**
 * Updates a BPay payment
 * @param paymentId
 * @param streamId
 * @param amount
 * @param dateExpected
 * @return {function(*=): (Promise.<T>|Promise.<T>)}
 */
export function updatePayment(paymentType : string, paymentId : string, streamId : string, amount : string, dateExpected : string, payeeDetails : PaymentDetailDTO = {}) : ThunkPromiseAction<Action>{
	let payeeDetailsSelect : PaymentDetailDTO = {
		paymentType: paymentType,
		paymentReference: payeeDetails.paymentReference,
		creditor: payeeDetails.payee
	}

	switch(paymentType){
		case 'B':
			Object.assign(payeeDetailsSelect, {
				billerCode: payeeDetails.billerCode
			})
			break

		case 'D':
			Object.assign(payeeDetailsSelect, {
				bsb: payeeDetails.bsb,
				accountNumber: payeeDetails.accountNumber
			})
			break
		case 'C':
			Object.assign(payeeDetailsSelect, {
				address1: payeeDetails.postalAddress.address,
				address2: payeeDetails.postalAddress.addressTwo,
				suburb: payeeDetails.postalAddress.suburb,
				state: payeeDetails.postalAddress.state,
				postCode: payeeDetails.postalAddress.postCode,
			})
			break
	}

	return (dispatch : Dispatch) =>
		loadingActions.promise(
			dispatch,
			BUDGET_UPDATE_PAYMENT,
			paymentAPI.updatePayment(paymentId, streamId, amount, dateExpected, payeeDetailsSelect)
				.then((id) => WS.waitFor(id))
				.then(() => dispatch(_removePayment(paymentId)))
		)
}

/**
 *
 * @param paymentId
 * @private
 */
export function _removePayment(paymentId : string) : Action{
	return {
		type: BUDGET_REMOVE_PAYMENT,
		paymentId: paymentId
	}
}

export function getPayees() : ThunkPromiseAction<Array<Creditor>>{
	return (dispatch : Dispatch) =>
		loadingActions.promise(
			dispatch,
			PAYMENT_GET_PAYEES,
			paymentAPI.getCreditors().then(payees => {
				dispatch(_getPayees(payees))
				return payees
			})
		)
}

export function _getPayees(payees : Array<Creditor>) : Action{
	return {
		type: PAYMENT_GET_PAYEES,
		payees: payees
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/payment.js